module.exports = __webpack_public_path__ + "static/media/filter-icon-black.ffd5575d.svg";